import styled from 'styled-components'
import {
  space,
  position,
  color,
  typography,
  border,
  layout,
  flexbox,
  grid,
  shadow,
  background,
} from 'styled-system'
import { Link } from 'gatsby'

export const StyledH1 = styled.h1`
  ${color}
  ${layout}
  ${typography}
  ${shadow}
  ${space}
`

export const StyledH2 = styled.h2`
  ${color}
  ${layout}
  ${typography}
  ${shadow}
  ${space}
`

export const StyledH3 = styled.h3`
  ${color}
  ${layout}
  ${typography}
  ${shadow}
  ${space}
`

export const StyledSection = styled.section`
  ${space}
  ${position}
  ${color}
  ${typography}
  ${border}
  ${layout}
  ${flexbox}
  ${grid}
  ${shadow}
  ${background}
`

export const StyledNav = styled.nav`
  ${space}
  ${position}
  ${color}
  ${typography}
  ${border}
  ${layout}
  ${flexbox}
  ${grid}
  ${shadow}
  ${background}
`

export const StyledP = styled.p`
  ${space}
  ${position}
  ${color}
  ${typography}
  ${border}
  ${layout}
  ${flexbox}
  ${shadow}
  ${background}
`

export const StyledBlockquote = styled.blockquote`
  ${space}
  ${position}
  ${color}
  ${typography}
  ${border}
  ${layout}
  ${flexbox}
  ${shadow}
  ${background}
`

export const StyledA = styled.a`
  ${space}
  ${position}
  ${color}
  ${typography}
  ${border}
  ${layout}
  ${flexbox}
`

export const StyledSpan = styled.span`
  ${color}
  ${typography}
`

export const StyledGatsbyLink = styled(Link)`
  ${space}
  ${position}
  ${color}
  ${typography}
  ${border}
  ${layout}
  ${flexbox}
`

export const StyledUL = styled.ul`
  ${space}
  ${position}
  ${color}
  ${typography}
  ${border}
  ${layout}
  ${flexbox}
  ${grid}
  ${background}
`

export const StyledLI = styled.li`
  ${space}
  ${position}
  ${color}
  ${typography}
  ${border}
  ${layout}
  ${flexbox}
  ${grid}
  ${background}
`

export const StyledForm = styled.form`
  ${space}
  ${position}
  ${color}
  ${typography}
  ${border}
  ${layout}
  ${flexbox}
  ${grid}
  ${background}
`

export const StyledInput = styled.input`
  ${space}
  ${position}
  ${color}
  ${typography}
  ${border}
  ${layout}
  ${flexbox}
  ${grid}
  ${background}
`

export const StyledButton = styled.button`
  ${space}
  ${position}
  ${color}
  ${typography}
  ${border}
  ${layout}
  ${flexbox}
  ${grid}
  ${background}
`
